export enum SoftwarePublishers {
  FieldManagement = "BPS-FM"
}
